import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { body2xl, bodyLg, d1, d2, outlineText, responsiveStyle } from '@helpers/typography';
import { horizontalFadeIn, horizontalFadeInCSS, verticalFadeIn, verticalFadeInCSS, } from '@helpers/variants';
import { Device, fluid, from, until } from '@netc/style-utils';
import SectionWrapper from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import SectionWrapperStyles from '@stories/Components/Misc/SectionWrapper/SectionWrapper.styles';
import { m } from 'framer-motion';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  overflow: hidden;

  ${SectionWrapperStyles.Inner} {
    --yPadding: ${fluid(15, 40)};
    --sectionSpacingTop: var(--yPadding);
    --sectionSpacingBottom: var(--yPadding);

    display: flex;
    flex-direction: column;
    gap: ${fluid(32, 48)};
  }
`;
const TopBar = styled.div `
  display: flex;
  gap: ${fluid(14, 20)};

  @media ${until(Device.ActualDesktop)} {
    flex-direction: column;
  }

  @media ${from(Device.ActualDesktop)} {
    justify-content: space-between;
    align-items: flex-end;
  }
`;
const Title = styled(m.h1).attrs(() => ({
    variants: horizontalFadeIn(-100),
})) `
  ${responsiveStyle(d2, d1)}
  ${horizontalFadeInCSS(Device.ActualDesktop)}
  word-wrap: break-word;
  overflow: hidden;

  > span[data-title] {
    ${outlineText(brand.global.white, brand.ngbBlue.default)}
  }

  @media ${from(Device.ActualDesktop)} {
    max-width: 50%;
  }
`;
const Intro = styled(m.p).attrs(() => ({
    variants: horizontalFadeIn(100),
})) `
  ${responsiveStyle(bodyLg, body2xl)}
  ${horizontalFadeInCSS(Device.ActualDesktop)}
  flex-shrink: 0;

  > strong {
    ${fonts.montserrat.bold}
  }

  @media ${from(Device.ActualDesktop)} {
    max-width: min(40%, 576px);
  }
`;
const SwappingWords = styled(m.div) `
  display: flex;
  position: relative;

  @media ${until(Device.Tablet)} {
    // Try to prevent jump on initial load
    min-height: ${fluid(36, 52)};
  }

  @media ${from(Device.ActualDesktop)} {
    display: inline;
  }
`;
const Word = styled(m.span).attrs((props) => ({
    initial: props['data-has-animated'] ? 'hiddenTop' : 'visible',
    animate: 'visible',
    exit: 'hiddenBottom',
    transition: {
        duration: 0.35,
        ease: [0.53, 0, 0.22, 1],
    },
    variants: {
        hiddenTop: {
            opacity: 0,
            position: 'absolute',
            y: '-100%',
        },
        visible: {
            opacity: 1,
            position: 'relative',
            y: '0%',
            transition: {
                duration: 0.75,
                ease: [0.53, 0, 0.22, 1],
            },
        },
        hiddenBottom: {
            opacity: 0,
            position: 'absolute',
            y: '100%',
        },
    },
})) `
  display: inline-block;
  vertical-align: baseline;

  // Not ideal but want to keep the text within the H1 a plain text element, not another DOM element like a span //
  -webkit-text-stroke: unset;
  -webkit-text-stroke-width: unset;
  color: ${brand.ngbBlue.default};

  @media ${until(Device.MobileLarge)} {
    ${fonts.montserrat.semiBold}
  }
`;
const VideoWrapper = styled(m.div).attrs(() => ({
    variants: verticalFadeIn(50),
})) `
  ${verticalFadeInCSS()}
  width: 100%;
  aspect-ratio: 343 / 488;
  border-radius: 8px;
  overflow: hidden;

  @media ${until(Device.Tablet)} {
    max-height: 500px;
  }

  @media ${from(Device.MobileLarge)} {
    aspect-ratio: 1776 / 740;
  }
`;
export const HeroBannerStyles = {
    Container,
    TopBar,
    Title,
    SwappingWords,
    Word,
    Intro,
    VideoWrapper,
};
